var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

jQuery(function($) {
  var path = window.location.href; 
  // because the 'href' property of the DOM element is the absolute path
  $('.header__menu a').each(function() {
    if (this.href === path) {
      $(this).addClass('active');
    }
  });
});


// Logo Slider

$().ready(function(){
  $('.logo-slide').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    autoplaySpeed: 4000,
    dots: false,
    arrows:false,
    infinite: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
});

// Lighbox Slider
$(".XXXXX__slider").slickLightbox({
    itemSelector: "a",
    navigateByKeyboard: true
});

